import AuthErrorBox from './AuthErrorBox';

export { AuthErrorBox };

export default AuthErrorBox;
